import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  categoryName: string;
  publishDate: string;
  readTime: string;
  author: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  coverImage,
  categoryName,
  publishDate,
  readTime,
  author,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full whitespace-nowrap">
            {categoryName}
          </span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{publishDate}</span>
        </div>
        <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="whitespace-nowrap">{author}</span>
          <span className="whitespace-nowrap flex items-center gap-1">
            <i className="ri-time-line"></i>
            {readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}